/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const SupplierOverviewPage = lazyLoad(
  () => import('./index'),
  module => module.SupplierOverviewPage
);
